import { ref, computed } from 'vue'

export const FIELD_TYPES = {
    TEXT: 'text',
    DATE: 'date',
    NUMBER: 'number',
    TIME: 'time',
    DATETIME: 'datetime-local',
    FILE: 'file',
    SELECT: 'select'
}

export const SELECT_SOURCES = {
    MANUAL: 'manual',
    API: 'api'
}

const createEmptyOption = () => ({ key: '', value: '' })

const createEmptyApproval = () => ({
    field_name: '',
    display_name: '',
    type: null,
    min: null,
    max: null,
    minlength: null,
    maxlength: null,
    max_size: null,
    accept: '.jpg, .jpeg, .png',
    selectSource: SELECT_SOURCES.MANUAL,
    selectOptions: [createEmptyOption()],
    apiUrl: ''
})

export function useApprovalFields(initialApprovals = []) {
    const approvals = ref(initialApprovals.map(approval => ({
        ...createEmptyApproval(),
        ...approval
    })))

    const addApproval = () => {
        approvals.value.push(createEmptyApproval())
    }

    const deleteApproval = (index) => {
        if (index !== 0) {
            approvals.value.splice(index, 1)
        }
    }

    const addSelectOption = (approval) => {
        approval.selectOptions.push(createEmptyOption())
    }

    const removeSelectOption = (approval, index) => {
        if (approval.selectOptions.length > 1) {
            approval.selectOptions.splice(index, 1)
        }
    }

    const isValid = computed(() => {
        return approvals.value.every(approval => {
            if (!approval.field_name || !approval.display_name || !approval.type) return false

            switch (approval.type) {
                case FIELD_TYPES.NUMBER:
                    return approval.max === null || approval.min === null || Number(approval.max) >= Number(approval.min)
                case FIELD_TYPES.TEXT:
                    return approval.maxlength === null || approval.minlength === null ||
                        Number(approval.maxlength) >= Number(approval.minlength)
                case FIELD_TYPES.SELECT:
                    if (approval.selectSource === SELECT_SOURCES.MANUAL) {
                        return approval.selectOptions.every(opt => opt.key && opt.value)
                    }
                    return !!approval.apiUrl
                default:
                    return true
            }
        })
    })

    const updateApprovalField = (index, field, value) => {
        if (index >= 0 && index < approvals.value.length) {
            approvals.value[index] = {
                ...approvals.value[index],
                [field]: value
            }
        }
    }

    return {
        approvals,
        addApproval,
        deleteApproval,
        addSelectOption,
        removeSelectOption,
        updateApprovalField,
        isValid
    }
}
